
import Vue from 'vue';
import store from '@/store';
import _ from 'lodash';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Getter } from 'vuex-class';
import { Menu } from '@/types/menus';
import { startCase } from 'lodash';
import MenuListTile from '../../components/Menu/MenuListTile.vue';

@Component({
  components: { MenuListTile },
})
export default class MenuList extends Vue {
  @Action('menus/getMenus') getMenus!: Function;
  @Getter('menus/menus') menus!: Menu[];

  get pageName() {
    const name = this.$route.name || undefined;
    return startCase(name);
  }

  get orderedMenus(): Menu[] {
    return _.orderBy(this.menus, ['name'], ['asc']);
  }

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    await store.dispatch('menus/getMenus');
    next();
  }

  newMenu() {
    this.$router.push('/menus/editor');
  }
}
